import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import API from "../../api/API";

const usePeople = (disabled = false) => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const isSupportal = window.location.pathname.startsWith("/supportal");

  const people = useQuery({
    queryKey: ["people"],
    queryFn: () => API.getAllPeople().then((data) => data.data.data.people),
    enabled: (queriesEnabled || isSupportal) && !disabled,
  });

  return {
    people: people.data,
    peopleLoading: people.isLoading,
  };
};

export default usePeople;
